import { tourStep } from './tourRegistry';

export const bandaTuWebSteps = [
  tourStep(
    'tuweb-sidebar',
    'Tu Web',
    'Micrositio público de la banda: estilos, qué secciones se ven, textos, publicación y dominio (incluido propio en planes que lo lleven).',
  ),
  tourStep(
    'tuweb-estilos',
    'Estilos',
    'Tema visual y tipografías. Los cambios son un borrador hasta que publiques.',
  ),
  tourStep(
    'tuweb-secciones',
    'Secciones',
    'Activa u oculta bloques de la web y cambia el orden. Solo las visibles se pueden editar en Contenido.',
  ),
  tourStep(
    'tuweb-contenido',
    'Contenido',
    'Textos, hero, plantilla de músicos, galería y contacto de cada sección activa.',
  ),
  tourStep(
    'tuweb-publicar',
    'Publicar',
    'Sube el borrador al subdominio. Hasta entonces la web pública no refleja lo que estás editando.',
  ),
  tourStep(
    'tuweb-dominio',
    'Dominio',
    'Elige el subdominio en Cadencya y, si tu plan lo incluye, un dominio propio.',
    'top',
  ),
];
